import React, { useEffect, useState } from 'react';
import DizeeInput from "../../../components/DizeeComponent/DizeeInput";
import dizeeLogo from "../../../assets/images/dizee logo.svg";
import AppleMusic from "../../../svg/Social/AppleMusic";
import Facebook from "../../../svg/Social/Facebook";
import Linkedin from "../../../svg/Social/Linkedin";
import Snapchat from "../../../svg/Social/Snapchat";
import Spotify from "../../../svg/Social/Spotify";
import Thread from "../../../svg/Social/Thread";
import TwitterX from "../../../svg/Social/TwitterX";
import Youtube from "../../../svg/Social/Youtube";
import Instagram from "../../../svg/SocialFeedPlatform/Instagram";
import Tiktok from "../../../svg/SocialFeedPlatform/Tiktok";
import TypeWriter from "../../../components/OnBoard/Typewriter";
import styled from "styled-components";
import AccessibilityWidget from "../../../components/AccessibilityWidget";import CrossArrow from "../../../svg/CrossArrow";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 350px;
  margin: 0 auto;
  padding-left: 35px;
  padding-top: 0;
  overflow: hidden;
  height: 100vh;
  position: relative;
  touch-action: none;
`;

const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 80px;
  gap: 2px;
  margin-top: -80px;
  height: 100%;
  position: relative;
  padding-top: 20px;
`;

const ScrollableSection = styled.div`
  max-height: 260px;
  overflow-y: auto;
  margin-bottom: 30px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Footer = styled.div`
  position: fixed;
  bottom: 27px;
  width: 280px;
`;

const LogoImage = styled.img`
  width: 48px;
  height: auto;
  margin-bottom: 16px;
`;

const FooterText = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  max-width: 280px;
  line-height: 1.5;
`;

const componentMapping = {
  IG: <Instagram />,
  TT: <Tiktok />,
  X: <TwitterX className="h-[15px] w-[15px]" />,
  FB: <Facebook className="h-[15px] w-[15px]" />,
  SC: <Snapchat className="h-[15px] w-[15px]" />,
  YT: <Youtube className="h-[15px] w-[15px]" />,
  SF: <Spotify className="h-[15px] w-[15px]" />,
  AM: <AppleMusic className="h-[15px] w-[15px]" />,
  TH: <Thread className="h-[15px] w-[15px]" />,
  LI: <Linkedin />,
};

// Add this function to extract usernames from URLs
const extractUsername = (url) => {
  if (!url) return '';
  
  // Remove protocol and www
  let cleanUrl = url.replace(/^(https?:\/\/)?(www\.)?/, '');
  
  try {
    // Extract username based on common social media URL patterns
    if (cleanUrl.includes('instagram.com/')) {
      // Display with @ for UI, even though URL doesn't have it
      return '@' + cleanUrl.split('instagram.com/')[1].split('/')[0].split('?')[0];
    } else if (cleanUrl.includes('tiktok.com/')) {
      // TikTok URLs may have @ in them
      const username = cleanUrl.split('tiktok.com/@')[1]?.split('/')[0].split('?')[0] || 
                    cleanUrl.split('tiktok.com/')[1]?.split('/')[0].split('?')[0];
      return username ? '@' + username.replace('@', '') : '';
    } else if (cleanUrl.includes('twitter.com/') || cleanUrl.includes('x.com/')) {
      // Display with @ for UI, even though URL doesn't have it
      return '@' + cleanUrl.split(/twitter\.com\/|x\.com\//)[1].split('/')[0].split('?')[0];
    } else if (cleanUrl.includes('facebook.com/')) {
      return cleanUrl.split('facebook.com/')[1].split('/')[0].split('?')[0];
    } else if (cleanUrl.includes('snapchat.com/')) {
      // Snapchat uses /add/username
      const username = cleanUrl.split('snapchat.com/add/')[1]?.split('/')[0].split('?')[0] || 
              cleanUrl.split('snapchat.com/')[1]?.split('/')[0].split('?')[0];
      return username ? '@' + username : '';
    } else if (cleanUrl.includes('youtube.com/')) {
      // Handle YouTube channel URLs, user URLs, etc.
      if (cleanUrl.includes('youtube.com/channel/')) {
        return cleanUrl.split('youtube.com/channel/')[1].split('/')[0].split('?')[0];
      } else if (cleanUrl.includes('youtube.com/c/')) {
        return cleanUrl.split('youtube.com/c/')[1].split('/')[0].split('?')[0];
      } else if (cleanUrl.includes('youtube.com/user/')) {
        return cleanUrl.split('youtube.com/user/')[1].split('/')[0].split('?')[0];
      } else {
        return cleanUrl.split('youtube.com/')[1].split('/')[0].split('?')[0];
      }
    } else if (cleanUrl.includes('spotify.com/')) {
      // Handle Spotify artist, user, playlist URLs
      if (cleanUrl.includes('spotify.com/artist/')) {
        return cleanUrl.split('spotify.com/artist/')[1].split('/')[0].split('?')[0];
      } else if (cleanUrl.includes('spotify.com/user/')) {
        return cleanUrl.split('spotify.com/user/')[1].split('/')[0].split('?')[0];
      } else {
        return cleanUrl.split('spotify.com/')[1].split('/')[0].split('?')[0];
      }
    } else if (cleanUrl.includes('music.apple.com/')) {
      // Handle Apple Music URLs like /us/artist/username/1392486216
      if (cleanUrl.includes('/artist/')) {
        const artistPath = cleanUrl.split('/artist/')[1];
        return artistPath.split('/')[0]; // Returns just the artist name
      } else {
        // For other Apple Music URL types
        return cleanUrl.split('music.apple.com/')[1].split('/').slice(1).join('/').split('?')[0];
      }
    } else if (cleanUrl.includes('threads.net/') || cleanUrl.includes('threads.com/')) {
      // Threads URLs include @ in them - extract username with the @
      const username = cleanUrl.split(/threads\.net\/|threads\.com\//)[1].split('/')[0].split('?')[0];
      // Ensure the @ is present for display
      return username.startsWith('@') ? username : '@' + username;
    } else if (cleanUrl.includes('linkedin.com/')) {
      // LinkedIn uses /in/username
      return cleanUrl.split('linkedin.com/in/')[1]?.split('/')[0].split('?')[0] || 
            cleanUrl.split('linkedin.com/')[1]?.split('/')[0].split('?')[0];
    }
    
    // If it doesn't match any pattern, return as is
    // If user entered a username with @, preserve it for display
    return url;
  } catch (error) {
    console.error("Error extracting username:", error);
    return url; // Return original value in case of errors
  }
};

// Function to format input as URL or keep as username
const formatSocialInput = (platform, input) => {
  if (!input) return '';
  
  // Check if input already looks like a URL
  if (input.includes('http://') || input.includes('https://') || 
      input.includes('.com') || input.includes('.net')) {
    return input; // Already a URL, keep as is
  }
  
  // Process based on platform
  switch(platform) {
    case 'ig':
      // Instagram doesn't use @ in the URL
      let igUsername = input.startsWith('@') ? input.substring(1) : input;
      return `https://instagram.com/${igUsername}`;
    case 'tt':
      // TikTok uses @ in the URL
      let ttUsername = input.startsWith('@') ? input.substring(1) : input;
      return `https://tiktok.com/@${ttUsername}`;
    case 'x':
      // X/Twitter doesn't use @ in the URL
      let xUsername = input.startsWith('@') ? input.substring(1) : input;
      return `https://x.com/${xUsername}`;
    case 'fb':
      let fbUsername = input.startsWith('@') ? input.substring(1) : input;
      return `https://facebook.com/${fbUsername}`;
    case 'sc':
      // Snapchat uses /add/username
      let scUsername = input.startsWith('@') ? input.substring(1) : input;
      return `https://snapchat.com/add/${scUsername}`;
    case 'yt':
      let ytUsername = input.startsWith('@') ? input.substring(1) : input;
      // Try to determine if it's a channel ID or username
      if (ytUsername.startsWith('UC') && ytUsername.length === 24) {
        return `https://youtube.com/channel/${ytUsername}`;
      }
      return `https://youtube.com/c/${ytUsername}`;
    case 'sf':
      let sfUsername = input.startsWith('@') ? input.substring(1) : input;
      return `https://open.spotify.com/user/${sfUsername}`;
    case 'am':
      let amUsername = input.startsWith('@') ? input.substring(1) : input;
      // For Apple Music, we'll keep as is if it seems like a complex URL
      // Otherwise, we'll treat it as an artist name
      if (amUsername.includes('/')) {
        return `https://music.apple.com/${amUsername}`;
      }
      return `https://music.apple.com/us/artist/${amUsername}`;
    case 'th':
      // Threads DOES use @ in the URL
      let thUsername = input.startsWith('@') ? input : '@' + input;
      return `https://threads.net/${thUsername}`;
    case 'li':
      // LinkedIn uses /in/username
      let liUsername = input.startsWith('@') ? input.substring(1) : input;
      return `https://linkedin.com/in/${liUsername}`;
    default:
      return input;
  }
};

// CLICKABLE SOCIAL LINKS - FUNCTIONALITY UPDATE
// ============================================== 
// Enhanced social media rows to be fully clickable:
// 1. Entire row (icon + input area) is clickable when URL exists
// 2. Links open in new tab to actual social media profile
// 3. Uses the full URL stored in user.social[platform] 
// 4. Maintains existing input functionality for editing
// 5. Visual feedback with hover effects for better UX
//
// IMPLEMENTATION:
// - SocialRow wrapper handles click events
// - Conditional rendering based on whether URL exists
// - Click opens window.open() with stored social URL
// - Input field remains editable with onChange handlers

const SocialRow = styled.div`
  margin-bottom: 27px;
  display: flex;
  font-family: default;
  gap: 10px;
  align-items: center;
  position: relative;
  border-radius: 8px;
  padding: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.02);
  }
`;

const IconWrapper = styled.div`
  cursor: ${props => props.hasUrl ? 'pointer' : 'default'};
  transition: all 0.2s ease;
  padding: 4px;
  border-radius: 6px;
  
  ${props => props.hasUrl && `
    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      transform: scale(1.05);
    }
  `}
`;

const InputWrapper = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
`;

const ArrowWrapper = styled.div`
  position: absolute;
  right: 8px;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  opacity: ${props => (props.show ? 1 : 0)};
  transform: ${props => (props.show ? 'translateX(0)' : 'translateX(10px)')};
  z-index: 10;
  background-color: #000000;
  
  &:hover {
    transform: ${props => (props.show ? 'scale(1.05)' : 'translateX(10px)')};
  }
`;

const Step9 = ({ setStep, setUser, user }) => {
  const [focusedInput, setFocusedInput] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.body.style.touchAction = 'none';
    
    return () => {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
      document.body.style.position = 'static';
      document.body.style.width = 'auto';
      document.body.style.height = 'auto';
      document.body.style.touchAction = 'auto';
    };
  }, []);

  // Function to handle social link clicks
  const handleSocialClick = (platform, socialUrl) => {
    if (socialUrl && socialUrl.trim()) {
      // Ensure URL has protocol
      const url = socialUrl.startsWith('http') ? socialUrl : `https://${socialUrl}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // Handle input focus
  const handleInputFocus = (platform) => {
    setFocusedInput(platform);
  };

  // Handle input blur
  const handleInputBlur = () => {
    setFocusedInput(null);
  };

  // Handle row hover
  const handleRowMouseEnter = (platform) => {
    setHoveredRow(platform);
  };

  const handleRowMouseLeave = () => {
    setHoveredRow(null);
  };

  // Check if arrow should be shown
  const shouldShowArrow = (platform, hasUrl) => {
    return hasUrl && (focusedInput === platform || hoveredRow === platform);
  };

  return (
    <Container>
      <FormSection>
        <div className="w-[200px]">
          <div className="font-default mb-[48px]">
            <TypeWriter text={"Add your social handles"} speed={45} />
          </div>

          <ScrollableSection>
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('ig')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.ig}
                onClick={() => handleSocialClick('ig', user?.social?.ig)}
              >
                {componentMapping["IG"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.ig)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, ig: formatSocialInput("ig", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('ig')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('ig', !!user?.social?.ig)}
                  onClick={() => handleSocialClick('ig', user?.social?.ig)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('tt')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.tt}
                onClick={() => handleSocialClick('tt', user?.social?.tt)}
              >
                {componentMapping["TT"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.tt)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, tt: formatSocialInput("tt", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('tt')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('tt', !!user?.social?.tt)}
                  onClick={() => handleSocialClick('tt', user?.social?.tt)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('x')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.x}
                onClick={() => handleSocialClick('x', user?.social?.x)}
              >
                {componentMapping["X"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.x)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, x: formatSocialInput("x", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('x')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('x', !!user?.social?.x)}
                  onClick={() => handleSocialClick('x', user?.social?.x)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('fb')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.fb}
                onClick={() => handleSocialClick('fb', user?.social?.fb)}
              >
                {componentMapping["FB"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.fb)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, fb: formatSocialInput("fb", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('fb')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('fb', !!user?.social?.fb)}
                  onClick={() => handleSocialClick('fb', user?.social?.fb)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('sc')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.sc}
                onClick={() => handleSocialClick('sc', user?.social?.sc)}
              >
                {componentMapping["SC"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.sc)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, sc: formatSocialInput("sc", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('sc')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('sc', !!user?.social?.sc)}
                  onClick={() => handleSocialClick('sc', user?.social?.sc)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('yt')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.yt}
                onClick={() => handleSocialClick('yt', user?.social?.yt)}
              >
                {componentMapping["YT"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.yt)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, yt: formatSocialInput("yt", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('yt')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('yt', !!user?.social?.yt)}
                  onClick={() => handleSocialClick('yt', user?.social?.yt)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('sf')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.sf}
                onClick={() => handleSocialClick('sf', user?.social?.sf)}
              >
                {componentMapping["SF"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.sf)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, sf: formatSocialInput("sf", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('sf')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('sf', !!user?.social?.sf)}
                  onClick={() => handleSocialClick('sf', user?.social?.sf)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('am')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.am}
                onClick={() => handleSocialClick('am', user?.social?.am)}
              >
                {componentMapping["AM"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.am)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, am: formatSocialInput("am", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('am')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('am', !!user?.social?.am)}
                  onClick={() => handleSocialClick('am', user?.social?.am)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('th')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.th}
                onClick={() => handleSocialClick('th', user?.social?.th)}
              >
                {componentMapping["TH"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.th)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, th: formatSocialInput("th", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('th')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('th', !!user?.social?.th)}
                  onClick={() => handleSocialClick('th', user?.social?.th)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
            
            <SocialRow 
              onMouseEnter={() => handleRowMouseEnter('li')}
              onMouseLeave={handleRowMouseLeave}
            >
              <IconWrapper 
                hasUrl={!!user?.social?.li}
                onClick={() => handleSocialClick('li', user?.social?.li)}
              >
                {componentMapping["LI"]}
              </IconWrapper>
              <InputWrapper>
                <DizeeInput
                  placeholder={"Username or URL"}
                  value={extractUsername(user?.social?.li)}
                  onChange={(e) =>
                    setUser({
                      ...user,
                      social: { ...user.social, li: formatSocialInput("li", e.target.value) },
                    })
                  }
                  onFocus={() => handleInputFocus('li')}
                  onBlur={handleInputBlur}
                />
                <ArrowWrapper 
                  show={shouldShowArrow('li', !!user?.social?.li)}
                  onClick={() => handleSocialClick('li', user?.social?.li)}
                >
                  <CrossArrow className="h-4 w-4" />
                </ArrowWrapper>
              </InputWrapper>
            </SocialRow>
          </ScrollableSection>

          <div className="font-default flex flex-row mt-[10px]">
            <div
              className="mr-[43px] cursor-pointer"
              onClick={() => setStep(22)}
            >
              Confirm
            </div>
            <div className="cursor-pointer" onClick={() => setStep(4.5)}>
              Go back
            </div>
          </div>
        </div>
      </FormSection>
      
      <Footer>
        <LogoImage src={dizeeLogo} alt="DIZEE" />
        <FooterText>
          These will be loaded on your brand page header but can be changed at any time
        </FooterText>
      </Footer>
      <AccessibilityWidget />
    </Container>
  );
};

export default Step9;
